<template lang="pug">
div
  .multiplaAction
    .buttonContainer
      button(@click='multipleSelec = !multipleSelec') selection multiple
    .removeUser.centering.iconContainer(
      v-if='multipleSelec',
      @click='$emit("remove-users-pack")'
    )
      i.far.fa-trash-alt
    .sendCode.centering(
      v-if='multipleSelec',
      @click='$emit("resend-pass-users-pack")'
    ) 
      p renvoyer code

  .handleOverflow
    .usersContainer(
      v-for='(user, key) in userList',
      :key='key',
      v-if='user.visible'
    )
      .userContainer(:class='getClass(key)')
        .centering.iconContainer(v-if='multipleSelec')
          input(type='checkbox', v-model='user.multipleSelection')
        .centering 
          p {{ user.name }}
        .centering.monospaceFont 
          p {{ user.code }}

        .centering 
          p(v-if='!user.editEmail') {{ user.email }}
          p(v-else)
            input.fix-size(
              v-model='user.email',
              type='email',
              v-on:keyup.enter='changeMail(user)'
            )

        .centering.iconContainer.updateMail(@click='handleClickEmail(user)')
          i.far.fa-envelope.float-right(v-if='!user.editEmail')
          i.fas.fa-envelope.float-right(v-else)

        .removeUser.centering.iconContainer(@click='removeUser(user.name)')
          i.far.fa-trash-alt
        .sendCode.centering(@click='sendCode(user)') 
          p renvoyer code
</template>

<script>
export default {
  props: ['userList'],
  data() {
    return {
      editMail: false,
      multipleSelec: false,
    }
  },
  methods: {
    handleClickEmail(user) {
      if (!user.editEmail) {
        user.editEmail = !user.editEmail
      } else {
        this.changeMail(user)
        user.editEmail = !user.editEmail
      }
    },
    changeMail(user) {
        let reg = /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/
        if (reg.test(user.email)) {
          // console.log(user.email)
          user.editEmail = false
          this.$emit('update-user-mail', user)
        } else {
          alert('adresse mail invalide')
        }
    },
    getClass(id) {
      let classCss = id % 2 ? 'odd' : 'even'
      classCss += this.multipleSelec ? ' multipleSelectGrid' : ' regularGrid'
      return classCss
    },
    removeUser(username) {
      this.$emit('remove-user', username)
    },
    sendCode(user) {
      this.$emit('sendcode', user)
    },
  },
}
</script>

<style>
.usersContainer.odd {
  background: #d0d0d0;
}
.float-right {
  float: right;
}

.fix-size {
  height: 9px;
  width: 85%;
}
.iconContainer {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.updateMail:hover .far.fa-envelope {
  color: orange;
}
.updateMail:hover .fas.fa-envelope {
  color: green;
}

.multiplaAction {
  background-color: white;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  align-items: center;
  padding: 10px 35px;
}

.multiplaAction p {
  margin: 0;
}
</style>
